// Mirrors Causable.Api.Data.Enum.EmailAuditStatusTypes.
export enum EmailAuditStatusTypes {
  Pending = 1,
  Accepted = 2,
  Rejected = 3,
  Failed = 4,
  SkippedSendingDisabled = 5,
  SkippedExcludedRecipient = 6,
  Unknown = 7
}

export const emailAuditStatusOptions = [
  {value: EmailAuditStatusTypes.Pending, name: 'Pending'},
  {value: EmailAuditStatusTypes.Accepted, name: 'Accepted'},
  {value: EmailAuditStatusTypes.Rejected, name: 'Rejected'},
  {value: EmailAuditStatusTypes.Failed, name: 'Failed'},
  {value: EmailAuditStatusTypes.SkippedSendingDisabled, name: 'Skipped - Sending Disabled'},
  {value: EmailAuditStatusTypes.SkippedExcludedRecipient, name: 'Skipped - Excluded Recipient'},
  {value: EmailAuditStatusTypes.Unknown, name: 'Unknown'}
];
